<div class="error-wrapper">
  <!-- Banner variant (rouge, message important) -->
  <div *ngIf="banner" class="error-banner" role="alert" aria-live="assertive">
    <div class="banner-inner">
      <div class="banner-content">
        <div class="banner-text" [innerHTML]="details"></div>
      </div>
    </div>
  </div>

  <!-- Card variant (technique / catalogue) -->
  <div *ngIf="!banner" class="error-card" role="alert" aria-live="assertive">
    <div class="accent"></div>

    <div class="error-icon" aria-hidden="true">
      <i class="fas fa-exclamation-triangle"></i>
    </div>

    <div class="error-body">
      <h3 *ngIf="title" class="error-title">{{ title }}</h3>

      <p *ngIf="reason" class="error-reason" [innerHTML]="reason"></p>
      <p *ngIf="details" class="error-details" [innerHTML]="details"></p>

      <div class="error-actions">
        <a class="btn outline" [href]="mailtoHref" rel="noopener">{{ 'button.contactBusiness' | translate }}</a>
      </div>

      <p class="error-hint">{{ errorFooter }}</p>
    </div>
  </div>
</div>